module.exports = __webpack_public_path__ + "static/lighting-table-headless-f3bbcd3059574cf5229cd6a1676175b7.png";